// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload {
  background: #fafafa;
  border: 1px dashed #c1c1c1;
  border-radius: 14px;
  text-align: center;
}
.file-upload__button {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  width: 100px;
  border-radius: 8px;
  height: 40px;
  padding: 12px 16px 12px 16px;
  cursor: pointer;
  background: #ffffff;
  color: #666666;
  border: 1px solid #e1e1e1;
  margin-top: 40px;
}
.file-upload__drag-file {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #c1c1c1;
  margin-top: 10px;
  margin-bottom: 40px;
}

.view-uploads {
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  padding: 15px;
  display: flex;
}
.view-uploads__icon {
  margin-top: 5px;
}
.view-uploads__file {
  margin-left: 10px;
  margin-top: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.view-uploads__remove {
  margin-left: auto;
  padding-top: 5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/common/file-upload/file-upload.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,0BAAA;EACA,mBAAA;EAEA,kBAAA;AAAJ;AAEI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAEA,kBAAA;EACA,YAAA;EAEA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EAEA,mBAAA;EACA,cAAA;EACA,yBAAA;EAEA,gBAAA;AAJR;AAOI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EAEA,gBAAA;EACA,mBAAA;AANR;;AAUA;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;AAPJ;AASI;EACI,eAAA;AAPR;AAUI;EACI,iBAAA;EACA,eAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATR;AAYI;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;AAVR","sourcesContent":[".file-upload {\n    background: #fafafa;\n    border: 1px dashed #c1c1c1;\n    border-radius: 14px;\n\n    text-align: center;\n\n    &__button {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 16px;\n\n        text-align: center;\n        width: 100px;\n\n        border-radius: 8px;\n        height: 40px;\n        padding: 12px 16px 12px 16px;\n        cursor: pointer;\n\n        background: #ffffff;\n        color: #666666;\n        border: 1px solid #e1e1e1;\n\n        margin-top: 40px;\n    }\n\n    &__drag-file {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        text-align: center;\n        color: #c1c1c1;\n\n        margin-top: 10px;\n        margin-bottom: 40px;\n    }\n}\n\n.view-uploads {\n    background: #ffffff;\n    border: 1px solid #e1e1e1;\n    border-radius: 8px;\n    padding: 15px;\n    display: flex;\n\n    &__icon {\n        margin-top: 5px;\n    }\n\n    &__file {\n        margin-left: 10px;\n        margin-top: 5px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    &__remove {\n        margin-left: auto;\n        padding-top: 5px;\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
